// DesActiva el boton de enviar cuando el formulario  no está validado
export function desActivarBTNSubmit() {

    const btnListActive = document.getElementsByClassName("btn_activo");
    const btnListNoActive = document.getElementsByClassName("btn_in_activo");

    for (let i = 0; i < btnListActive.length; ++i) {
        btnListActive[i].style.display = "none";
        btnListActive[i].disabled = true;
        btnListNoActive[i].style.display = "block";
    }
}

// Activa el boton de enviar cuando el formulario está validado
export function activarSubmitBtn() {

    const btnListActive = document.getElementsByClassName("btn_activo");
    const btnListNoActive = document.getElementsByClassName("btn_in_activo");

    for (let i = 0; i < btnListActive.length; ++i) {
        btnListActive[i].style.display = "block";
        btnListActive[i].disabled = false;
        btnListNoActive[i].style.display = "none";
    }
}


// WEBPACK FOOTER //
// ./js/utils/modal/handleBTNSubmit.js